import { TrackedChangeItem } from 'stores/DocStore.types'
import Avatar from 'common/Avatar/Avatar'
import { useAuth } from 'hooks/UseAuth'
import { useUserCard } from 'hooks/queries/users/useUserCard'
import Styles from './TrackedChangeItemSummary.module.scss'
import { getInitials } from 'utils'
import { TrackedChangeIcon } from 'components/CollabItemInlineWidget/TrackedChangeIcon'

interface Props {
  collabItem: TrackedChangeItem
  isActive: boolean
}

export const TrackedChangeItemSummary = ({ collabItem, isActive }: Props) => {
  const auth = useAuth()
  const userQuery = useUserCard(collabItem.item.userId, {
    // 1 day
    staleTime: 24 * 60 * 60 * 1000,
    refetchOnMount: false,
  })

  const user = userQuery.data?.user
  const byMe = auth && user?.id === auth.id
  const userName = user?.display_name || 'Anonymous'

  return (
    <div className={Styles.avatar}>
      <Avatar url={user?.avatar_url} label={byMe ? 'You' : getInitials(userName)} size={isActive ? 20 : 24} />
      <TrackedChangeIcon type={collabItem.item.type} className={Styles.icon} />
    </div>
  )
}
